var render = function render(){var _vm=this,_c=_vm._self._c;return _c('properties-block',_vm._g(_vm._b({scopedSlots:_vm._u([{key:"layout",fn:function(){return undefined},proxy:true}])},'properties-block',_vm.$props,false),_vm.$listeners),[_c('properties-component-link',_vm._b({attrs:{"title":"Link|Lien","value":_vm.block.link}},'properties-component-link',_vm.componentProps,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }